"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.filter");

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background: transparent !important;\n  color: ", " !important;\n  padding: 0;\n  width: 100%;\n  transition: opacity 0.25s linear;\n  opacity: 0.75;\n  position: relative;\n  * {\n    transition: color 0.25s linear, opacity 0.25s linear;\n  }\n  &.checked,\n  &:hover {\n    opacity: 1;\n    ", " {\n      opacity: 1;\n    }\n  }\n  &.disabled {\n    opacity: 0.5 !important;\n    ", " {\n      opacity: 0 !important;\n    }\n  }\n  &.checked * {\n    color: ", ";\n  }\n  &:not(:last-child) {\n    margin-bottom: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0;\n  transition: opacity 0.25s linear;\n  position: absolute;\n  top: 0;\n  right: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin: 10px 0;\n  font-size: 14px;\n  line-height: 1.5;\n  align-items: flex-start;\n  position: relative;\n  background: ", ";\n  transition: background 0.1s linear, color 0.1s linear, opacity 0.1s linear;\n  color: ", ";\n  padding: 10px 10px 10px 20px;\n  opacity: 1;\n  border-radius: ", ";\n  cursor: pointer;\n  outline: none;\n  border: none;\n  &:hover {\n    background: ", ";\n    color: white;\n  }\n  > div {\n    flex-grow: 1;\n    margin: 0 0 0 10px;\n    text-align: left;\n    > p {\n      margin-top: 0;\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n    > strong {\n      font-size: 18px;\n    }\n  }\n  svg {\n    font-size: 20px;\n    margin-top: 5px;\n  }\n  &[disabled] {\n    opacity: 0.5;\n    cursor: default;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LargeCheckbox = exports.LargeButton = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var styledTypes_1 = require("./styledTypes");

var Container = styledTypes_1.styled.button(_templateObject(), function (props) {
  return props.theme['@gray-1'];
}, function (props) {
  return props.theme['@text-color'];
}, function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@blue'];
});

function LargeButton(_ref) {
  var title = _ref.title,
      children = _ref.children,
      icon = _ref.icon,
      onClick = _ref.onClick,
      disabled = _ref.disabled;
  return react_1["default"].createElement(Container, {
    onClick: onClick,
    disabled: disabled
  }, icon, react_1["default"].createElement("div", null, react_1["default"].createElement("strong", null, title), children));
}

exports.LargeButton = LargeButton;

function LargeCheckbox(_a) {
  var title = _a.title,
      children = _a.children,
      icon = _a.icon,
      rest = __rest(_a, ["title", "children", "icon"]);

  var classNames = [rest.checked ? 'checked' : undefined, rest.disabled ? 'disabled' : undefined].filter(Boolean);
  return react_1["default"].createElement(CheckboxContainer, {
    className: classNames.join(' '),
    onClick: function onClick() {
      if (rest.onChange) {
        rest.onChange({
          target: {
            checked: !rest.checked
          }
        });
      }
    }
  }, icon, react_1["default"].createElement("div", null, react_1["default"].createElement("strong", null, title), children), react_1["default"].createElement(CheckboxInnerContainer, {
    onClick: function onClick(e) {
      return e.preventDefault();
    }
  }, react_1["default"].createElement(antd_1.Checkbox, Object.assign({}, rest))));
}

exports.LargeCheckbox = LargeCheckbox;
var CheckboxInnerContainer = styledTypes_1.styled.div(_templateObject2());
var CheckboxContainer = (0, styledTypes_1.styled)(Container)(_templateObject3(), function (props) {
  return props.theme['@text-color'];
}, CheckboxInnerContainer, CheckboxInnerContainer, function (props) {
  return props.theme['@primary-color'];
}, function (props) {
  return props.theme['@size-xs'];
});